import { Decoration } from '@atlaskit/editor-prosemirror/view';

export type TelepointerElements = {
	element: HTMLSpanElement;
	labelElement: HTMLSpanElement;
};

export const createTelepointerElement = (label: string): TelepointerElements => {
	const element = document.createElement('span');
	element.setAttribute('data-testid', `ai-in-editor-telepointer-widget`);
	element.className = `ai-in-editor-telepointer`;

	const labelElement = document.createElement('span');
	labelElement.setAttribute('data-testid', `ai-in-editor-telepointer-widget-label`);
	labelElement.className = `ai-in-editor-telepointer-label`;
	labelElement.append(label);
	element.appendChild(labelElement);

	return { element, labelElement };
};

export const createTelepointerWidget = (position: number, element: HTMLElement): Decoration => {
	return Decoration.widget(position, element, {
		side: 0,
		key: 'inEditorAIContentDecoration',
	});
};
